// extracted by mini-css-extract-plugin
export default {"circle_background":"CircularProgress_circle_background__kl-Xo","circle_progress":"CircularProgress_circle_progress__nqRhJ"};